import { FETCH_FREE_BET_PAGE } from "../actions/types";

export default (state = "loading", action) => {
  switch (action.type) {
    case FETCH_FREE_BET_PAGE:
      return action.payload;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/freeBetPageReducer.js